import { useEffect, useMemo } from 'react';
import {
  onCreateMeeting,
  onDeleteMeeting,
  onUpdateMeeting,
} from '@/services/graphql/subscriptions';
import { actions } from '@/store/slices/meeting';
import { useAppDispatch } from '@/store/StoreHooks';
import { fetchMeetingList } from '@/store/thunk/meeting';
import {
  Meeting,
  OnCreateMeetingSubscription,
  OnDeleteMeetingSubscription,
  OnUpdateMeetingSubscription,
} from '../API';
import useNewSubscriptions from './useNewSubscriptions';

function useMeetingSubscription() {
  const dispatch = useAppDispatch();

  const subscriptions = useMemo(() => {
    return [
      {
        query: onCreateMeeting,
        variables: {},
        callback: (data: OnCreateMeetingSubscription) => {
          dispatch(actions.newMeeting(data.onCreateMeeting as Meeting));
        },
      },
      {
        query: onUpdateMeeting,
        variables: {},
        callback: (data: OnUpdateMeetingSubscription) => {
          dispatch(actions.receivedMeetingUpdate(data.onUpdateMeeting as Meeting));
        },
      },
      {
        query: onDeleteMeeting,
        variables: {},
        callback: (data: OnDeleteMeetingSubscription) => {
          dispatch(actions.deleteMeeting(data.onDeleteMeeting as Meeting));
        },
      },
    ];
  }, []);

  useNewSubscriptions(subscriptions, 'useMeetingSubscription');

  useEffect(() => {
    // initial fetch
    dispatch(fetchMeetingList());
  }, []);
}

export default useMeetingSubscription;
